import OpenSeadragon from 'openseadragon';

/** Re-dispatches a wheel event on the OSD container so BaseSlideMapOSD's wheel zoom handles it. */
export const forwardWheelToViewer = (viewer, e) => {
    if (!viewer?.container) return;
    e.preventDefault();
    e.stopPropagation();
    const rect = viewer.container.getBoundingClientRect();
    const forwarded = new WheelEvent('wheel', {
        bubbles: true, cancelable: true,
        deltaX: e.deltaX, deltaY: e.deltaY, deltaZ: e.deltaZ, deltaMode: e.deltaMode,
        clientX: e.clientX, clientY: e.clientY,
        ctrlKey: e.ctrlKey, shiftKey: e.shiftKey, altKey: e.altKey, metaKey: e.metaKey,
    });
    Object.defineProperty(forwarded, 'offsetX', {value: e.clientX - rect.left});
    Object.defineProperty(forwarded, 'offsetY', {value: e.clientY - rect.top});
    viewer.container.dispatchEvent(forwarded);
};

/** Pans through the viewport API; synthetic events do not drive OSD's MouseTracker reliably. */
export const panViewerByPixels = (viewer, dx, dy) => {
    if (!viewer?.viewport) return;
    viewer.viewport.panBy(viewer.viewport.deltaPointsFromPixels(new OpenSeadragon.Point(dx, dy)), false);
    viewer.viewport.applyConstraints();
};
